import React, { useState } from 'react'
import { adminRequest } from '../api/client'
import { setAdminSession } from '../data/adminSession'

export default function Login({ navigate, onAuthenticated }) {
  const [loginId, setLoginId] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  const submit = async (event) => {
    event.preventDefault()
    if (busy) return
    setBusy(true)
    setError('')
    try {
      await adminRequest('/api/v1/admin/auth/login', {
        method: 'POST',
        body: { loginId: loginId.trim(), password },
      })
      const sessionResponse = await adminRequest('/api/v1/admin/auth/me')
      const admin = sessionResponse?.data || null
      if (!admin) throw new Error('관리자 세션을 확인할 수 없습니다.')
      setAdminSession(admin)
      onAuthenticated?.(admin)
      navigate('/dashboard')
    } catch (loginError) {
      setAdminSession(null)
      setPassword('')
      setError(loginError?.message || '로그인에 실패했습니다.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="login-page">
      <div className="login-card">
        <div className="login-brand"><div className="admin-brand-mark">D</div><div><strong>difan</strong><span>ADMIN</span></div></div>
        <div className="login-heading"><span>ADMIN CONSOLE · LIVE AUTH</span><h1>관리자 로그인</h1><p>DIFAN 운영 관리자 전용 화면입니다.</p></div>
        <form onSubmit={submit}>
          <label>관리자 ID<input required type="text" autoComplete="username" value={loginId} onChange={(event) => setLoginId(event.target.value)} placeholder="관리자 ID" /></label>
          <label>비밀번호<input required type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} placeholder="비밀번호를 입력하세요" /></label>
          {error && <p className="login-note" style={{ color: '#b42318' }}>{error}</p>}
          <button disabled={busy} type="submit" className="button primary wide">{busy ? '로그인 확인 중…' : '로그인'}</button>
        </form>
        <p className="login-note">로그인 성공 후 서버 쿠키 세션을 다시 검증하며, 임의 입력으로는 관리자 화면에 진입할 수 없습니다.</p>
      </div>
    </main>
  )
}
